import React from 'react';

// import './index.scss';

//other libraries
import { inject, observer } from 'mobx-react';
import {Helmet} from "react-helmet";


@inject('internal')
@inject('translate')
@observer
export default class HtmlTitle extends React.Component {

    render() {
        return (
            <Helmet>
                <title>
                    {this.props.internal.headerTitle ? this.props.internal.headerTitle : ""}
                    &nbsp;-&nbsp;
                    {this.props.internal.user && 
                    this.props.internal.user.data && 
                    this.props.internal.user.data.seo_title 
                        ?
                        this.props.internal.user.data.seo_title 
                        : 
                        ""
                    }
                </title>
            </Helmet>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/basic/htmlTitle/index.js